import "./production-overrides.css";

const textUpdates = new Map([
  ["Rashmi Pandey — Founder", "Meet our Founder — Rashmi Pandey"],
  ["M.A. Political Science, Jamshedpur Women's College", "M.A. Political Science, Jamshedpur Women's College, Jamshedpur, INDIA"],
  ["7 years of online teaching experience", "7+ years of online teaching experience"],
  ["60-minute private lessons", "45-minute private lessons"],
]);

const applyUpdates = () => {
  document.querySelectorAll("p, li").forEach((element) => {
    const replacement = textUpdates.get(element.textContent.trim());
    if (replacement) element.textContent = replacement;
  });
};

new MutationObserver(applyUpdates).observe(document.documentElement, { childList: true, subtree: true });
applyUpdates();
